<template>
  <DialogModal :is-destructive-alert="true" @secondary="$emit('cancel')" @primary="$emit('delete')">
    <span slot="header" v-localize="HEADER_TEXT_KEY" />
    <span slot="body" v-localize="BODY_TEXT_KEY" />
    <span slot="secondary-button-text" v-localize="SECONDARY_BUTTON_TEXT_KEY" />
    <span slot="primary-button-text" v-localize="PRIMARY_BUTTON_TEXT_KEY" />
  </DialogModal>
</template>

<script>
import DialogModal from '@/components/AvatarBuilderUI/Dialogs/DialogModal.vue';
import { LocalizationDirective } from '@/directives/LocalizationDirective';

export default {
  name: 'DeleteSelfiePreviewDialog',
  components: {
    DialogModal,
  },
  created: function() {
    this.HEADER_TEXT_KEY = 'DeleteSelfieDialogTitle';
    this.BODY_TEXT_KEY = 'DeleteSelfieDialogMessage';
    this.SECONDARY_BUTTON_TEXT_KEY = 'Cancel';
    this.PRIMARY_BUTTON_TEXT_KEY = 'Delete';
  },
  directives: {
    LocalizationDirective,
  },
};
</script>
